module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password background-color long-contents"
  }, [_c('app-header-noauth'), _c('div', {
    staticClass: "div text-center"
  }, [_c('div', {
    staticClass: "row margin-top"
  }), _c('div', {
    staticClass: "row margin-top"
  }), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "container text-center"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('span', [_c('label', {
    staticClass: "forgot-password-title"
  }, [_vm._v(_vm._s(_vm.$t('forgot_password.title')))])]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.$t('forgot_password.subtitle')))])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "div center-block"
  }, [_c('div', {
    staticClass: "col-xs-11 margin-left margin-right"
  }, [(!_vm.isForgotPasswordSuccess) ? _c('span', [_c('label', [_vm._v(_vm._s(_vm.$t('forgot_password.input_email')))]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    style: (_vm.border),
    attrs: {
      "id": "email",
      "type": "email",
      "name": "email",
      "require": "require"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]) : _vm._e(), (_vm.showMessage) ? _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "alert",
    class: {
      'alert-success': _vm.isForgotPasswordSuccess, 'alert-danger': !_vm.isForgotPasswordSuccess
    }
  }, [_vm._v(_vm._s(_vm.message))])]) : _vm._e()]), _c('div', {
    staticClass: "col-xs-11 margin-left margin-right"
  }, [_c('div', {
    staticClass: "text-left"
  }, [(!_vm.isForgotPasswordSuccess) ? _c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('forgot_password.note_1')))]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('forgot_password.note_2')))]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('forgot_password.note_3')))])]) : _vm._e()])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-11 margin-left margin-right"
  }, [(!_vm.isForgotPasswordSuccess) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "text-center col-xs-12"
  }, [_c('button', {
    staticClass: "col-xs-12 btn btn-default btn-lg bg-success forgot-password-send-btn btn-gradation",
    attrs: {
      "id": "logion",
      "type": "button",
      "disabled": !_vm.canSubmit()
    },
    on: {
      "click": function($event) {
        _vm.sendMail()
      }
    }
  }, [_c('span', {
    staticClass: "login-btn"
  }, [_vm._v(_vm._s(_vm.$t('forgot_password.send')) + " ")]), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "white"
    }
  })])])]) : _vm._e(), _c('div', {
    staticClass: "form-group text-center"
  }, [(!_vm.isForgotPasswordSuccess) ? _c('span', {
    staticClass: "small"
  }, [_vm._v("パスワードをリセットしない場合は")]) : _vm._e(), _c('br'), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('u', {
    staticClass: "span small"
  }, [_vm._v(_vm._s(_vm.$t('forgot_password.back_to_login')))])])], 1)])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f26753b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/forgot-password.pug
// module id = 1374
// module chunks = 1